<footer class="ma__footer js-footer" id="footer">
  <div class="ma__footer__container">
      <div class="ma__footer__nav">
          <section class="ma__footer-links">
              <nav aria-labelledby="block-footer1-menu" id="block-footer1" role="navigation">
                  <h2 class="visually-hidden" id="block-footer1-menu">
                      Footer Primary Links
                  </h2>
                  <ul class="ma__footer-links__items">
                      <li class="ma__footer-links__item">
                          <span class="ma__decorative-link">
                              <a href="https://www.mass.gov/orgs/massachusetts-department-of-environmental-protection" class="js-clickable-link" target="_blank" title="Go to external link name(opens in new window)">
                                Department of Environmental Protection (DEP)
                                  <span class="sr-only">Opens in new window</span>
                                  
                                  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="16" viewBox="0 0 17 16">
                                      <defs></defs>
                                      <path d="M739.199 92.7986L739.199 80L735.9989999999999 80L735.9989999999999 95.9983L751.9979999999999 95.9983L751.9979999999999 92.7986ZM743.294 81.0032L743.305 83.5605L746.6049999999999 83.5737L742.9939999999999 87.1849L744.809 89.0001L748.4259999999999 85.3836L748.4399999999999 88.6956L750.997 88.7058L750.976 83.59129999999999L750.966 81.03389999999999L748.409 81.02349999999998L748.409 81.02369999999999Z " transform="matrix(1,0,0,1,-735,-80)"></path>
                                  </svg>

                              </a>
                          </span>
                      </li>
                  </ul>
                  <ul class="ma__footer-links__items">
                    <li class="ma__decorative-link">
                      <a href="https://www.mass.gov/privacypolicy" class="js-clickable-link" target="_blank" title="Go to external link name(opens in new window)">Mass.gov Privacy Policy
                        <span class="sr-only">Opens in new window</span>
                                  
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="16" viewBox="0 0 17 16">
                            <defs></defs>
                            <path d="M739.199 92.7986L739.199 80L735.9989999999999 80L735.9989999999999 95.9983L751.9979999999999 95.9983L751.9979999999999 92.7986ZM743.294 81.0032L743.305 83.5605L746.6049999999999 83.5737L742.9939999999999 87.1849L744.809 89.0001L748.4259999999999 85.3836L748.4399999999999 88.6956L750.997 88.7058L750.976 83.59129999999999L750.966 81.03389999999999L748.409 81.02349999999998L748.409 81.02369999999999Z " transform="matrix(1,0,0,1,-735,-80)"></path>
                        </svg>

                    </a>
                    </li>
                </ul>

                  <ul class="ma__footer-links__items  version">
                      <li class="ma__footer-links__item">
                          <p>V1.0</p>
                      </li>
                  </ul>

              </nav>
          </section>
      </div>

      <section class="ma__footer__info">
          <div class="ma__footer__logo">
              <img alt="Massachusetts State Seal" height="50" src="https://eeadev.eea.state.ma.us/eea/cdn/v4/img/stateseal.png" width="50">
          </div>

          <div class="ma__footer__copyright">
              <p>
                  <strong>© 2022 Commonwealth of Massachusetts.</strong>
              </p>

              <p>
                  Mass.Gov® is a registered service mark of the Commonwealth of Massachusetts.
              </p>
             
          </div>
      </section>
  </div>

  <div class="scroll-to-top float-right" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button type="button" class="btn active" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
        <i style="color: white;" class="fa fa-angle-up"></i>
    </button>
  </div>
</footer>

<!-- /footer -->